import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doctor-professional-transaction-status',
  templateUrl: './doctor-professional-transaction-status.component.html',
  styleUrls: ['./doctor-professional-transaction-status.component.css']
})
export class DoctorProfessionalTransactionStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
